// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header-1zUpD";
var _3 = "direction-jqy7W";
var _4 = "description-1ypqk";
export { _1 as "__esModule", _2 as "header", _3 as "direction", _4 as "description" }
export default { "__esModule": _1, "header": _2, "direction": _3, "description": _4 }
